{
  "schemaVersion": 1,
  "key": "forest",
  "name": "Forest",
  "version": "1.0.0",
  "author": "classy core",
  "backgrounds": {
    "home": "backgrounds/home.png"
  },
  "mascot": {
    "home": "mascot/moose.png"
  },
  "tokens": {
    "accent": "#3E6DAD"
  }
}
